"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOWNLOAD_SECTIONS = exports.FINANCIAL_MODELS_LABEL = void 0;
const Constants_1 = require("../Constants");
exports.FINANCIAL_MODELS_LABEL = 'Financial models';
exports.DOWNLOAD_SECTIONS = [
    {
        label: 'Business overview deck',
        documentTypes: [Constants_1.CompanyFileDocumentType.BusinessOverviewDeck],
    },
    {
        label: exports.FINANCIAL_MODELS_LABEL,
        documentTypes: [
            Constants_1.CompanyFileDocumentType.CashFlowStatement,
            Constants_1.CompanyFileDocumentType.IncomeStatement,
            Constants_1.CompanyFileDocumentType.BalanceSheet,
        ],
    },
    {
        label: 'Cap table',
        documentTypes: [Constants_1.CompanyFileDocumentType.CapTable],
    },
    {
        label: 'Additional documents',
        documentTypes: [Constants_1.CompanyFileDocumentType.Other],
    },
];
//# sourceMappingURL=CompanyDataRoom.js.map